import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwZorg,
  SpecificatieZorgkosten
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-zorgkosten',
  templateUrl: './spec-zorgkosten.component.html',
  styleUrls: ['./spec-zorgkosten.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class SpecZorgkostenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    specZorgkostenFormGroup = this.fb.group<AangifteRapport>({});
    specZorgkosten = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specZorgkostenFormGroup = this.fb.group<AangifteRapport>(({
            specificatieZorgkosten: this.fb.group<SpecificatieZorgkosten>(({
                opbouw: this.fb.group<OpbouwZorg>(({
                    behandelKosten: null as unknown as number,
                    medicijnKosten: null as unknown as number,
                    hulpmiddelen: null as unknown as number,
                    extraGezinshulp: null as unknown as number,
                    aftrekbaarExtraGezinshulp: null as unknown as number,
                    reiskostenEigenZorg: null as unknown as number,
                    reiskostenGezinslid: null as unknown as number,
                    kledingEnBeddengoed: null as unknown as number,
                    dieetkosten: null as unknown as number,
                    totaalZorgkostenVoorVerhoging: null as unknown as number,
                    verhogingZorgkosten: null as unknown as number,
                    zorgkostenVoorDrempel: null as unknown as number,
                    drempelZorgkosten: null as unknown as number,
                    aandeelZorgkosten: null as unknown as number,
                    aftrekbareZorgkosten:null as unknown as number
                } as OpbouwZorg))
            } as SpecificatieZorgkosten))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specZorgkosten = value;
                    this.specZorgkostenFormGroup.patchValue(this.specZorgkosten)
                });
                this.disableFormGroup(this.specZorgkostenFormGroup);
            }
        });
    }

    // get isZorgkostenVoorDrempelLessThanDrempelZorgkosten(): boolean {
        // const zorgkostenVoorDrempel = this.specZorgkostenFormGroup.get('specificatieZorgkosten', 'opbouw', ) || 0;
        // const drempelZorgkosten = this.getPropertyValue('drempelZorgkosten') || 0;
        // return zorgkostenVoorDrempel < drempelZorgkosten;
    // }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    protected readonly Object = Object;
}
